import Vue from 'vue'
import Router from 'vue-router'
//import home from '@/components/home'
import home from '@/page/newHomePage/newHome.vue'
import newHome from "@/page/newHomePage/newHome.vue"
import product from '@/components/product'
import market from '@/components/market'
import marketC from '@/components/marketC'
import partners from '@/components/partners'
import news from '@/components/news'
import newsDetail from '@/components/news_detail'
import publicity from '@/components/publicity'
import agent from '@/components/agent'
import about from '@/components/about'
import system from '@/components/system/system'
import retrospect from '@/components/retrospect'
import elmmarket from '@/components/elmmarket'
import zycpzs from '@/components/zycpzs'
import ygst from '@/components/ygst'
import cyqy from '@/components/cyqy'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}
export default new Router({
	mode: 'history',
	routes: [{
		path: '/',
		name: 'home',
		component: home
	},
	{
		path: '/newHome',
		name: "newHome",
		component: newHome
	}, {
		path: '/publicity',
		name: 'publicity',
		component: publicity,
	},
	{
		path: '/retrospect',
		name: 'retrospect',
		component: retrospect,
	},
	{
		path: '/elmmarket',
		name: 'elmmarket',
		component: elmmarket,
	},
	{
		path: '/zycpzs',
		name: 'zycpzs',
		component: zycpzs,
	},
	{
		path: '/ygst',
		name: 'ygst',
		component: ygst,
	},
	{
		path: '/Apublicity',
		name: 'Apublicity',
		component: publicity,
	},
	{
		path: '/Bpublicity',
		name: 'Bpublicity',
		component: publicity,
	},
	{
		path: '/Cpublicity',
		name: 'Cpublicity',
		component: publicity,
	},
	{
		path: '/Dpublicity',
		name: 'Dpublicity',
		component: publicity,
	},
	{
		path: '/product',
		name: 'product',
		component: product
	},
	{
		path: '/market',
		name: 'market',
		component: market
	},
	{
		path: '/marketC',
		name: 'marketC',
		component: marketC
	},
	{
		path: '/partners',
		name: 'partners',
		component: partners
	},
	{
		path: '/news',
		name: 'news',
		component: news
	},
	{
		path: '/newsDetail',
		name: 'newsDetail',
		component: newsDetail
	},
	{
		path: '/agent',
		name: 'agent',
		component: agent
	},
	{
		path: '/about',
		name: 'about',
		component: about
	},
	{
		path: '/system',
		name: 'system',
		component: system
	}, {
		path: '/cyqy',
		name: 'cyqy',
		component: cyqy
	}

	],
	scrollBehavior(to, from, savedPosition) {
		// return 期望滚动到哪个的位置
		if (to.name == 'system') {
			return {
				x: 0,
				y: 620
			}
		} else if (to.name == 'marketC') {
			return {
				x: 0,
				y: 450
			}
		} else {
			return {
				x: 0,
				y: 0
			}
		}

	}

})



// WEBPACK FOOTER //
// ./src/router/index.js